import React from 'react';

import { EmptyAvailableCandidateFilters, useIsPhone } from '@hooks';
import { SHOW_CANDIDATE_MARKS } from '@utils';
import { CandidateFilters } from 'components/candidate/CandidatesList/components/CandidateFilters';
import { ColumnMenu } from 'components/candidate/CandidatesList/components/ColumnMenu';
import { ListToolbar } from 'components/candidate/CandidatesList/components/ListToolbar';
import { ShowSkippedToggle } from './ShowSkippedToggle';
import {
  AvailableCandidateFilterSections,
  offersAvailableFilterChoice,
} from './AvailableCandidateFilterSections';
import { AvailableCandidatesSearch } from './AvailableCandidatesSearch';
import { AvailableCandidateColumns } from './columns';
import { IAvailableCandidatesControls } from './controls';

export const AvailableCandidatesToolbar: React.FC<
  IAvailableCandidatesControls
> = ({
  candidates,
  filterOptions,
  view,
  activeFilterCount,
  skippedCount,
  isDefault,
  onChange,
  onReset,
}) => {
  const isPhone = useIsPhone();

  const search = (
    <AvailableCandidatesSearch
      fullWidth={isPhone}
      candidates={candidates}
      value={view.query}
      onChange={(query) => onChange({ query })}
    />
  );

  if (isPhone) return search;

  return (
    <ListToolbar
      isDefault={isDefault}
      onReset={onReset}
      search={search}
      filters={
        <CandidateFilters
          activeCount={activeFilterCount}
          canFilter={offersAvailableFilterChoice(filterOptions)}
          onClear={() => onChange(EmptyAvailableCandidateFilters)}
        >
          <AvailableCandidateFilterSections
            options={filterOptions}
            filters={view}
            onChange={onChange}
          />
        </CandidateFilters>
      }
      actions={
        <>
          {SHOW_CANDIDATE_MARKS && (
            <ShowSkippedToggle
              view={view}
              count={skippedCount}
              onChange={onChange}
            />
          )}

          <ColumnMenu
            columns={AvailableCandidateColumns}
            selected={view.columns}
            onChange={(columns) => onChange({ columns })}
          />
        </>
      }
    />
  );
};
